import format from 'date-fns/format';
import { utcToZonedTime } from 'date-fns-tz'

export function formatDate(date: Date | string, formatter: string) : string {
  if (typeof date === 'string') {
    date = new Date(date);
  }

  return format(date, formatter);
}

export function convertToZonedTime(utcDate: Date | string, timezone: string = 'UTC') : Date {
  return utcToZonedTime(new Date(utcDate), timezone);
}
